export { default } from './SearchSectionRugsRugContainer';
